
import { clearOldLocalStorageEntries } from './app-initialization.core.js';

export async function initializeDateFilters() {
    try {
        let dF = null, dT = null;
        if (window.$ && window.$.urlParam) {
            dF = window.$.urlParam('date-from');
            dT = window.$.urlParam('date-to');
        }

        if (dF || dT) {
            const dateFromInput = $('.filter-date-from');
            const dateToInput = $('.filter-date-to');
            if (dF && dateFromInput.length > 0) dateFromInput.val(dF);
            if (dT && dateToInput.length > 0) dateToInput.val(dT);
            
            // Also sync with DateFiltersManager if available
            if (window.dateFiltersManager && typeof window.dateFiltersManager.setDateRange === 'function') {
                window.dateFiltersManager.setDateRange(dF || '', dT || '', true); // true = skip URL update during initialization
            }
            
            // Also sync with LiteDateRangePicker if available (for the visible date range picker in filters panel)
            if (window.__drp && typeof window.__drp.applyRange === 'function') {
                try {
                    const fromDate = dF ? new Date(dF + 'T00:00:00') : null;
                    const toDate = dT ? new Date(dT + 'T00:00:00') : null;
                    window.__drp.applyRange(fromDate, toDate, 'restore');
                } catch(e) {
                    // Non-blocking - LiteDateRangePicker might not be ready yet
                }
            }
        }

        clearOldLocalStorageEntries();
    } catch (error) { throw error; }
}


